import http from "../http-common";

export const getMeData = (params) => {
    return http.get("/me", { params });
};